<template>
    <div class="input select">
        <select ref="select">
            <option v-if="placeholder"></option>
            <slot></slot>
        </select>
    </div>
</template>

<script>
import $ from 'jquery'
import 'select2'

export default {
    props: {
        value: {
            type: [String, Number, Object],
            default: null
        },
        groups: {
            type: [Array, Object, Function],
            default: null
        },
        choices: {
            type: [Array, Object, Function],
            default: () => []
        },
        options: {
            type: Object,
            default: () => { }
        },
        placeholder: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            instance: null
        }
    },
    watch: {
        groups (value) {
            this.build()
        },
        choices (value) {
            this.build()
        }
    },
    methods: {
        build () {
            const data = this.groups || this.choices
            this.instance = $(this.$refs.select).select2({
                data,
                theme: 'bootstrap4',
                placeholder: this.placeholder,
                width: '100%',
                ...this.options
            })

            this.instance.on('select2:select', this.onSelect)
        },
        clearSelection () {
            $(this.$refs.select).val(null).trigger('change')
        },
        onSelect (e) {
            this.$emit('update:modelValue', e.params.data.value)
        }
    },
    mounted () {
        this.build()
    },
    destroyed () {
        this.instance.select2('destroy')
    }
}

// Add focus to select on Screen Type dropdown
$(document).on('select2:open', () => {
    document.querySelector('.select2-search__field').focus();
});
</script>
